import * as api from "./client";
import type { LoginCredentials, AuthResponse, PlatformUser } from "@/types";

// auth APIs - Platform module
const registerPath = "/platform/auth/platform/register";
const loginPath = "/platform/auth/platform/login";
const refreshTokenPath = "/platform/auth/refresh";
const logoutPath = "/platform/auth/logout";
const getMePath = "/platform/auth/me";
const validateTokenPath = "/platform/auth/me";

export async function login(
  credentials: LoginCredentials
): Promise<AuthResponse> {
  return api.request<AuthResponse>(loginPath, {
    method: "POST",
    body: JSON.stringify(credentials),
  });
}

export async function register(data: {
  name: string;
  email: string;
  password: string;
  roleId: number;
}): Promise<{ data: PlatformUser }> {
  return api.request(registerPath, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function refreshToken(refreshToken: string): Promise<{
  accessToken: string;
  refreshToken: string;
}> {
  return api.request(refreshTokenPath, {
    method: "POST",
    body: JSON.stringify({ refreshToken }),
  });
}

export async function logout(refreshToken?: string): Promise<void> {
  return api.request(logoutPath, {
    method: "POST",
    body: JSON.stringify({ refreshToken }),
  });
}

export async function getCurrentUser(): Promise<{ data: PlatformUser }> {
  return api.request(getMePath);
}

export async function validateToken(
  token: string
): Promise<{ data: PlatformUser }> {
  return api.request(validateTokenPath, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function registerCompanyUser(data: {
  name: string;
  email: string;
  password: string;
  companyId: string;
  departmentId?: string;
}): Promise<{ data: PlatformUser }> {
  return api.request(
    "/platform/auth/company/register",
    {
      method: "POST",
      body: JSON.stringify(data),
    }
  );
}

export async function updateMe(data: {
  fullName?: string;
  email?: string;
  password?: string;
}): Promise<PlatformUser> {
  return api.request<PlatformUser>("/platform/auth/me", {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}
